import PropTypes from 'prop-types';
import { getIn } from 'formik';

import { FormikPropTypes } from '../propTypes';

const ErrorMessage = ({ formik, name }) => {
  const touch = getIn(formik.touched, name);
  const error = getIn(formik.errors, name);

  return !!touch && !!error
    ? error
    : null;
};

ErrorMessage.propTypes = {
  formik: FormikPropTypes.isRequired,
  name: PropTypes.string.isRequired,
};

export default ErrorMessage;
